import { gql } from '@apollo/client';

export const INVITE_FIELDS = gql`
  fragment InviteFields on Invite {
    id
    userRole
    invitingUserRole
    email
    tenantId
    clientId
    createdAt
    updatedAt
    itemStatus
    invitingUserId
    inviteLink
    inviteSentAt
    siteIds
  }
`;

export const GET_INVITES = gql`
  ${INVITE_FIELDS}
  query GetInvites {
    getInvites {
      ...InviteFields
    }
  }
`;

export const GET_OUTSTANDING_INVITES_FOR_CLIENT = gql`
  ${INVITE_FIELDS}
  query GetOutstandingInvitesForClient($clientId: String!) {
    getOutstandingInvitesForClient(clientId: $clientId) {
      ...InviteFields
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser(
    $email: String!
    $role: UserRole!
    $tenantId: String
    $clientId: String
    $siteIds: [String!]
  ) {
    inviteUser(
      email: $email
      role: $role
      tenantId: $tenantId
      clientId: $clientId
      siteIds: $siteIds
    )
  }
`;

export const GET_INVITES_BY_USER = gql`
  ${INVITE_FIELDS}
  query GetInvitesSentByUser($userId: String!) {
    getInvitesSentByUser(userId: $userId) {
      ...InviteFields
    }
  }
`;

export const REVOKE_INVITE = gql`
  mutation RevokeInvite($id: String!) {
    revokeInvite(id: $id)
  }
`;
